import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
    yellow: "#FFDE03",
    red: "#B00020",
    black: {
        darkest: "#141414",
        darker: "#181818",
        lighter: "#2F2F2F",
    },
    white: {
        lighter: "#FFFFFF",
        darker: "#E5E5E5",
    },
    padding: {
        desktop: "60px",
        mobile: "40px",
    },
};
